<div *ngIf="showLoading" class="flexCenter">
    <mat-spinner></mat-spinner>
</div>

<div *ngIf="!showLoading">
    <div *ngIf="statisticForm.value.REQUEST_STATE != '5' && statisticForm.value.REQUEST_STATE != '13' || this.authService.currentUser().ROLE != authRole.InternalAdmin && this.authService.currentUser().ROLE != authRole.InternalUser; else error">
        <h1>{{"statisticForm" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Title"}}</h1>
        <app-formular [formBuilderInput]="statisticForm" [formular]="statisticFormular"></app-formular>
    
        <div *ngIf="this.authService.currentUser().ROLE == 'IN_ADM' || this.authService.currentUser().ROLE == 'IN_USR'">
            <app-grid-template class="gridTemplate" [columns]="MS_REQSERV_NColumns" [enableHideEmpty]="true" [urlString]="MS_REQSERV_NUrlString" [title]="'ASSETS'" (action)="action($event)"></app-grid-template>
            <br>
        </div>
    
        <div *ngIf="this.authService.currentUser().ROLE == 'IN_ADM' || this.authService.currentUser().ROLE == 'IN_USR'">
            <app-grid-template class="gridTemplate" [columns]="MS_REQCASSET_NColumns" [enableHideEmpty]="true" [urlString]="MS_REQCASSET_NUrlString" [title]="'CRITICALASSETS'" (action)="action($event)"></app-grid-template>
            <br>
        </div>
    
        <div>
            <app-grid-template class="gridTemplate" [columns]="MS_REQDOC_STATColumns" [enableHideEmpty]="true" [urlString]="MS_REQDOC_STATUrlString" [title]="'cptn_PlotOverview'" (action)="action($event)" [groupName]="groupName"></app-grid-template>
        </div>
        <br>
        <button mat-raised-button (click)="backAction()">{{"btn_back" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
    </div>
    
    <ng-template #error class="statisticErrorRequestTab">
        <mat-tab-group mat-stretch-tabs>
            <mat-tab [label]="this.translateResourceDefinition.transform('statisticForm', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', 'LOGIN')">
    
                <app-formular [formBuilderInput]="statisticForm" [formular]="statisticFormular"></app-formular>
    
                <div *ngIf="this.authService.currentUser().ROLE == 'IN_ADM' || this.authService.currentUser().ROLE == 'IN_USR'">
                    <app-grid-template class="gridTemplate" [columns]="MS_REQSERV_NColumns" [enableHideEmpty]="true" [urlString]="MS_REQSERV_NUrlString" [title]="'ASSETS'" (action)="action($event)"></app-grid-template>
                    <br>
                </div>
    
                <div *ngIf="this.authService.currentUser().ROLE == 'IN_ADM' || this.authService.currentUser().ROLE == 'IN_USR'">
                    <app-grid-template class="gridTemplate" [columns]="MS_REQCASSET_NColumns" [enableHideEmpty]="true" [urlString]="MS_REQCASSET_NUrlString" [title]="'CRITICALASSETS'" (action)="action($event)"></app-grid-template>
                    <br>
                </div>
    
                <div>
                    <app-grid-template class="gridTemplate" [columns]="MS_REQDOC_STATColumns" [enableHideEmpty]="true" [urlString]="MS_REQDOC_STATUrlString" [title]="'cptn_PlotOverview'" (action)="action($event)" [groupName]="groupName"></app-grid-template>
                </div>
                <br>
                <button mat-raised-button (click)="backAction()">{{"btn_back" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
            </mat-tab>
            <mat-tab [label]="this.translateResourceDefinition.transform('historyForm', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', 'LOGIN')">
                <app-grid-template class="gridTemplate" [columns]="processingHistory" [enableHideEmpty]="false" [urlString]="processingHistoryUrlString" [defaultFilter]="processingHistoryDefaultFilter" [title]="'cptn_processHistory'" (action)="action($event)"></app-grid-template>
    
                <app-grid-template class="gridTemplate" [columns]="plotRequest" [enableHideEmpty]="false" [urlString]="plotRequestUrlString" [defaultFilter]="plotRequestUrlStringDEfaultFilter" [title]="'cptn_pltorequestDetail'" (action)="action($event)"></app-grid-template>
    
                <button mat-raised-button (click)="restartRequestAction()">{{"btn_restartRequest" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
    
            </mat-tab>
        </mat-tab-group>
    
    </ng-template>
</div>